import { createContext, useContext } from 'react'
import type { ResolvedTheme, ThemePreference } from '@app/theme-preference'

export interface ThemePreferenceContextValue {
  preference: ThemePreference
  resolvedTheme: ResolvedTheme
  setPreference: (preference: ThemePreference) => void
}

export const ThemePreferenceContext = createContext<ThemePreferenceContextValue | null>(null)

export function useThemePreference() {
  const context = useContext(ThemePreferenceContext)
  if (!context) throw new Error('useThemePreference must be used within ThemePreferenceProvider')
  return context
}
